import { useRouteError } from "react-router-dom";
import { ErrorState } from "@/components/ui/error-state";

/**
 * Route-level error element for the /admin subtree (routes.tsx).
 *
 * createBrowserRouter handles render errors with React Router's built-in
 * full-screen error UI unless a route provides `errorElement` — a classic
 * <ErrorBoundary> wrapped around <RouterProvider> never fires for these.
 * Mounted on a pathless route under AdminLayout so a crashing admin page
 * only blanks the Outlet and the admin chrome stays navigable (motivating
 * incident: 2026-06-12 /admin/health `ai_agent` contract-drift TypeError).
 */
export function AdminRouteError() {
  const error = useRouteError();
  const description =
    error instanceof Error
      ? error.message
      : "An unexpected error occurred while rendering this page.";

  return (
    <ErrorState
      variant="full"
      message="This admin page crashed"
      description={description}
      onRetry={() => window.location.reload()}
      retryText="Reload"
    />
  );
}
